import { ClientNamesResponseType, InfiniteData } from '@ukpostbox/client-data';
import {
	ComboBoxControl,
	ComboBoxItemDisplayEnum,
	ComboBoxTypeEnum,
	SelectItemType,
} from '@ukpostbox/frontend-framework';
import { useEffect, useState } from 'react';
import { useForwardingBatchProvider } from '../../Providers/ForwardingBatchProvider';

type AccountNamesComboboxType = {
	name: string;
	callback: (item: SelectItemType) => void;
	defaultValue?: string;
	disabled?: boolean;
};

function AccountNamesCombobox(props: AccountNamesComboboxType) {
	const { accountNamesData, accountNamesStatus, accountNamesError } = useForwardingBatchProvider();
	const [nameOptions, setNameOptions] = useState<Array<SelectItemType>>([]);

	const MapUserOptions = (data: InfiniteData<ClientNamesResponseType>) => {
		const filteredPostage = data?.pages.map(
			(page) => page?.data && page.data.map((name, index: number) => ({ label: name.name, value: name.name })),
		);

		setNameOptions(filteredPostage.flat());
	};

	const HandleCallback = (item: SelectItemType) => {
		props.callback(item);
	};

	useEffect(() => {
		if (accountNamesData) {
			MapUserOptions(accountNamesData);
		}
	}, [accountNamesData]);

	return (
		<ComboBoxControl
			data={nameOptions}
			valueType='string'
			name={props.name}
			placeholder=''
			displayType={ComboBoxTypeEnum.Single}
			displayItemLabelType={ComboBoxItemDisplayEnum.Label}
			forwardItemCallback={(item) => HandleCallback(item)}
			loading={accountNamesStatus === 'pending'}
			defaultValue={[props.defaultValue]}
			disabled={props.disabled}
		/>
	);
}

export { AccountNamesCombobox };
